import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=0557b44d&scoped=true"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"
import style0 from "./Products.vue?vue&type=style&index=0&id=0557b44d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0557b44d",
  null
  
)

export default component.exports